import React from 'react';
import { registerWidget } from '@okapi/core';
import {
  SavedProjectConfigurationsList,
  SavedProjectConfigurationsListProps,
  SavedProjectConfigurationsListState,
} from 'entries/common/widgets';
import { createApi } from 'utils/api';

registerWidget<SavedProjectConfigurationsListProps, SavedProjectConfigurationsListState>(
  `${__NAME__}/savedProjectConfigurationsList`,
  state => props => {
    const host = state.env.ORCHESTRATOR_HOST;
    const apiKey = state.env.API_KEY;
    const api = createApi(host, apiKey);
    return <SavedProjectConfigurationsList {...state} {...props} api={api} />;
  }
);
